/**
 * Client-side storage service — the ONLY thing in the student app
 * allowed to touch /api/storage/*. Every engine that persists data
 * (Memory, Homework, Bookmarks) goes through this, never fetch()
 * directly, so the R2 key convention stays centralized in one place.
 */
export async function getObject<T>(key: string): Promise<T | null> {
  const res = await fetch(`/api/storage/${key}`);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(`Storage GET failed: ${res.status}`);
  return res.json();
}

export async function putObject<T extends object>(key: string, value: T): Promise<T> {
  const res = await fetch(`/api/storage/${key}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(value),
  });
  if (!res.ok) throw new Error(`Storage PUT failed: ${res.status}`);
  return res.json();
}

export async function deleteObject(key: string): Promise<void> {
  const res = await fetch(`/api/storage/${key}`, { method: "DELETE" });
  if (!res.ok) throw new Error(`Storage DELETE failed: ${res.status}`);
}
